import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../auth/services/auth.service';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (
  route,
  state
) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService
    .check()
    .pipe(
      map((authenticated) =>
        authenticated || router.parseUrl(authService.signInUrlForEndedSession(state.url))
      )
    );
};
